import React, { FC } from 'react'

import { IconCommunityProps } from './IconCommunity.types'
import * as Styled from './styles/IconCommunity.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCommunity: FC<IconCommunityProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCommunityProps['size'],
  isResponsive = false,
}: IconCommunityProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M28.5 35.75a14.837 14.837 0 0 0 7.032-4.825m-23.062-.002a14.83 14.83 0 0 0 7.03 4.827M9.53 18.668a14.823 14.823 0 0 0 .658 8.5M21.723 7a14.75 14.75 0 0 0-7.69 3.685m19.932-.003A14.75 14.75 0 0 0 26.278 7m11.535 19.977a14.815 14.815 0 0 0 .657-8.5'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 41a4.557 4.557 0 1 0 0-9.115A4.557 4.557 0 0 0 24 41Zm12.825-22.212a4.558 4.558 0 1 0 0-9.116 4.558 4.558 0 0 0 0 9.116Zm-25.65 0a4.557 4.557 0 1 0 0-9.115 4.557 4.557 0 0 0 0 9.115Z'
          stroke='#fff'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCommunity
